export {
    SearchResultsLoader,
    ArticleResultsLoader,
    SidePanelResultsLoader,
    SearchResultsLoader as NewSearchResultsLoader,
} from './loading';
